import classes from './pagination.module.css'

const Pagination = {
  classNames: {
    control: classes.control,
  },
}

export default Pagination
